module.exports = __webpack_public_path__ + "img/4.a5803158.png";